<template>
  <div>
    <b-input-group v-for="dim in dimension" :key="dim.value">
      <b-input-group-prepend><label>{{dim.text}}</label></b-input-group-prepend>
      <b-form-input readonly v-model="model[`${dim.value}Info`]" ></b-form-input>
    </b-input-group>
  </div>
</template>

<style lang="scss">
.lku-dimval {
  td {
    padding: 0;

    a {
      //   border: 1px solid;
      text-decoration: none;
      display: block;
      padding: 0.5rem 0.75rem;
    }
  }
}
</style>


<script>
export default {
  data() {
    return {
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
  },
  props: ["model"],
   created: async function() {
      this.dimension.forEach(dim => {
         if (!(this.model[`${dim.value}Info`])) {
          this.model[`${dim.value}Info`]=this.model[`${dim.value}info`]
         }
      });
  },
 
};
</script>
